import { TableCell, TableRow, Typography } from '@mui/material';
import { Box } from '@mui/system';
import Moment from 'react-moment';
import { CustomTooltip } from '../../../../components/CustomTooltip';
import { DATE_FORMAT } from '../../../../consts';
import { TalentsActions } from '../../TalentsActions';
import style, { BlockCenter, ImageProfile, WrapperBlock } from './style';

type TalentsRowItemProps = {
  talent: Talent,
  onRowClick: () => void,
}

export const TalentsRowItem = ({
  talent,
  onRowClick,
}: TalentsRowItemProps):JSX.Element => {
  return (
    <TableRow
      key={ talent.talentId + talent.firstName }
      sx={ style.tableRow }
      onClick={ onRowClick }
      hover
    >
      <TableCell sx={ style.profileCell.sx }>
        <WrapperBlock>
          <BlockCenter>
            <ImageProfile
              src={ talent.profileImage }
              alt={ talent.firstName }
            />
          </BlockCenter>
          <Box width={ 200 }>
            <CustomTooltip title={ `${talent.firstName} ${talent.lastName}` }>
              <Typography
                noWrap
                variant="subtitle2"
              >
                {`${talent.firstName} ${talent.lastName}`}
              </Typography>
            </CustomTooltip>
            <CustomTooltip title={ talent.talentId }>
              <Typography
                noWrap
                color="textSecondary"
                variant="body2"
              >
                {talent.talentId}
              </Typography>
            </CustomTooltip>
          </Box>
        </WrapperBlock>

      </TableCell>

      <TableCell sx={ style.tableCell.sx }>
        <CustomTooltip title={ talent?.currentJob?.companyName }>
          <Typography
            noWrap
            variant="body2"
          >
            {talent?.currentJob?.companyName}
          </Typography>
        </CustomTooltip>
      </TableCell>

      <TableCell sx={ style.tableCell.sx }>
        <CustomTooltip title={ talent.currentJob?.jobTitle }>
          <Typography
            noWrap
            variant="body2"
          >
            {talent?.currentJob?.jobTitle}
          </Typography>
        </CustomTooltip>
      </TableCell>

      <TableCell sx={ style.dateCell.sx }>
        <Moment format={ DATE_FORMAT.TABLE_LIST }>
          {talent.updatedAt}
        </Moment>
      </TableCell>

      <TableCell sx={ style.dateCell.sx }>
        <Moment format={ DATE_FORMAT.TABLE_LIST }>
          {talent.createdAt}
        </Moment>
      </TableCell>

      <TableCell style={ style.tabelCell } sx={ style.menuCell.sx }>
        <TalentsActions talentId={ talent.talentId } />
      </TableCell>
    </TableRow>
  );
};
